import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Actions from 'actions';

const mapStateToProps = ({ sales_site_manager, routing }) => ({ ...(sales_site_manager || []), pathname: routing && routing.locationBeforeTransitions ? routing.locationBeforeTransitions.pathname : '' });
export default (Component) => connect(
  mapStateToProps,
  Actions
)(withRouter(Component));



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/connect.js